import { logger } from "@/utils/logger";
import {Task, TaskDefinition, TaskExecuteAction, TaskState,} from "@/types";
import {Paths, taskVariables, UON} from "@/utils";
import {api} from "@/auth/api";
import {executeTask} from "@/store/services/task/workflow";
import {getTasks} from "@/store/services/task/taskService";
import store from "@/store";

export async function executeDelegationLevelAction(payload: {taskState: TaskState, task: Task}) {
    const {taskState, task} = payload

    let delegationLvl = taskState.updateDelegationLvlProcess

/*
    const returnedToAnalysis = store.getters["taskModule/getIsReturnedToAnalysis"];
    if (returnedToAnalysis){
        delegationLvl = '';
        store.state.taskModule.updateDelegationLvlProcess = '';  
    }
*/

    const updateDelegationLevelWhenExistsOne = async () => {
        if (delegationLvl) {
            await updateDelegationLevel({
                decisionProcessId: task.variables.decisionProcessId,
                delegationLevelId: delegationLvl,
                systemUid: UON.SystemUid.odmDecision,
                daaq: "/"
            });
        } else logger.info('No delegation level provided');
    }

    try {
        const recentTask = await getMostRecentTaskStep(task);
        if (TaskDefinition.DELEGATION_LEVEL === recentTask.taskDefinition) {
            const taskExecuteAction: TaskExecuteAction = {
                taskId: recentTask.taskId || "",
                variables: {
                    updatedDelegationLvlProcess: {
                        value: delegationLvl,
                        type: "String"
                    },
                    salesManager: {
                        value: JSON.stringify(store.state.demandModule.salesManager) ?? {},
                        type: "Json"
                    },
                    delegationLVLComment: {
                        value: store.state.taskModule.delegationLvlComment ?? '',
                        type: "String"
                    },
                    active_user:{value : JSON.stringify(store.getters['authModule/getActiveUserInfo']), type: "Json"}
                },
            };
            await updateDelegationLevelWhenExistsOne();
            return executeTask(taskExecuteAction);
        }
        else {
            logger.debug(`The task ${recentTask.taskId} is not a delegation level task.`)
        }
    } catch (e) {
        logger.error(e);
        return Promise.reject(e);
    }
}

/**
 * Update the delegation level using the provided payload.
 *
 * @param {unknown} payload - The data payload for updating the delegation level.
 * @return {void}
 */
const updateDelegationLevel = async (payload: unknown): Promise<void> => {
    const response = await api().put(
        `/${UON.SystemUid.odmDecision}/api/1/${UON.SystemUid.odmDecision}/${Paths.updateDelegationLevel}/`,
        payload
    );
    logger.info(response.data);
}

const getMostRecentTaskStep = async (task: Task) => {
    const taskFilter = {
        searchVariables: JSON.stringify([{
            name: "offerReference",
            operator: "eq",
            value: task.variables.offerReference || '',
        }]),
        initializeVariables: taskVariables.offer,
        includeAssignedTasks: true,
    }
    return await getTasks(taskFilter).then(async res => {
        return {
            taskDefinition: res.data[0].taskDefinition,
            taskId: res.data[0].taskId
        }
    })
}

